<form [formGroup]="_gestionTercerosService.customerForm">
    <div class="row" formGroupName="contactInformation">



        <div class="fondo-gris" *ngIf="showModalGeneric || showModalNewContract || showModalComunicationAlert"> </div>

        <app-generic-modal *ngIf="showModalGeneric" [title]="generic_title" [textButtonOk]="generic_textButtonOk"
            [textButtonCancel]="generic_textButtonCancel" [aspa]="generic_aspa" [message]="generic_message"
            [isButtonOk]="generic_isButtonOk" [isButtonCancel]="generic_isButtonCancel"
            (modalClose)="closeModalGeneric($event)">
        </app-generic-modal>

        <app-generic-modal *ngIf="showModalNewContract" [title]="'labels.aviso'" [textButtonOk]="'labels.aceptar'"
            [textButtonCancel]="'labels.cancelar'" [aspa]="false" [message]="'labels.nuevoContrato'"
            [isButtonOk]="true" [isButtonCancel]="true"
            (modalClose)="closeModalNewContract($event)">
        </app-generic-modal>

        <app-generic-modal *ngIf="showModalComunicationAlert" [title]="'labels.aviso'" [textButtonOk]="'labels.aceptar'"
            [textButtonCancel]="'labels.cancelar'" [aspa]="false" [message]="'alerts.avoid_inform_export'"
            [isButtonOk]="true" [isButtonCancel]="true"
            (modalClose)="closeModalComunicationAlert($event)">
        </app-generic-modal>

        <div class="col-12 mr-1 ml-1 mt-2 ">

            <!-- Fila  Telefono-->
            <div class="row altura1_7 pr-1 pl-1">
                <div class="form-group_terceros datos_identificacion col-4" *ngIf="pais !== 'fr' ">
                    <label class="text-not-over mt-1 pix_50"
                        title="{{'labels.movil' | translate}}">{{'labels.movil' | translate}}:</label>
                    <input appDigitOnly [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                        formControlName="telephonePortable" type="text" class="form-control float-right anchurax50 ">
                </div>
                <div class="form-group_terceros datos_identificacion col-4" *ngIf="pais === 'fr' ">
                    <label title="{{'labels.movil' | translate}}"
                        class="mt-1 anchurax30 text-not-over">{{'labels.movil' | translate}}:</label>
                    <input appDigitOnly [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                        formControlName="telephonePortable" type="text" class="form-control float-right anchurax65 ">
                </div>

                <div class="form-group_terceros datos_identificacion col-4">
                    <label title="{{'labels.telefonoFijo' | translate}}" class="mt-1 anchurax40 text-not-over">
                        {{'labels.telefonoFijo' | translate}}:</label>
                    <input appDigitOnly [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                        formControlName="telephoneHome" type="text" class="form-control  float-right anchurax55 ">
                </div>

                <div class="form-group_terceros datos_identificacion col-4">
                    <label title=" {{'labels.telephoneOffice' | translate}}" class="anchurax40 text-not-over">
                        {{'labels.telephoneOffice' | translate}}:</label>
                    <input appDigitOnly [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                        formControlName="telephoneOffice" type="text" class="form-control   float-right anchurax55">
                </div>
            </div>

            <!-- Fila  fax-->
            <div class="row altura1_7 pr-1 pl-1">
                <div class="form-group_terceros datos_identificacion col-4" *ngIf="pais !== 'fr' ">
                    <label class="">
                        {{'labels.fax' | translate}}:</label>
                    <input appDigitOnly [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                        formControlName="fax" type="text" class="form-control anchurax75 float-right">
                </div>
                <div class="form-group_terceros datos_identificacion col-4" *ngIf="pais === 'fr' ">
                    <label class="anchurax35">
                        {{'labels.fax' | translate}}:</label>
                    <input appDigitOnly [attr.disabled]="formMode || !modoEdicion? true: null" maxlength="20"
                        formControlName="fax" type="text" class="form-control anchurax65 float-right">
                </div>
                <div class=" form-group_terceros datos_identificacion col-8"
                    [ngClass]="{ 'popoverClassic_blue': mailMal  }">
                    <label class="">
                        {{'labels.email' | translate}}:</label>
                    <input popoverPlacement="bottom" [popoverOnHover]="false" [popover]="myPopover10"
                        [attr.disabled]="formMode || !modoEdicion? true: null" [ngClass]="{ 'form-no-valid': mailMal}"
                        maxlength="50" formControlName="email" type="text" class="form-control anchurax80 float-right">
                    <popover-content #myPopover10>
                        <div class="body-tooltip" *ngIf="mailMal">
                            <span
                                [innerHtml]="'errors.required.formatoErroneo' | translate | returnHtml: 'html'"></span>
                        </div>
                    </popover-content>
                </div>
            </div>

            <div class="row mt-1  pl-2 text-size-xSmall">
                <div class="col-6">
                    <span class="text-bold "> {{ 'gestion_terceros.contactInformation.FLDPrivacy' | translate}}</span>
                        <div class="col-sm-12 pl-0">
                            <kendo-dropdownlist [data]="privacyData" [textField]="'description'"
                            [valueField]="'value'" [valuePrimitive]="true"
                            formControlName="privacy">
                            <ng-template kendoDropDownListItemTemplate let-dataItem>
                                <span class="kendo_list_template">{{ dataItem.description }}</span>
                            </ng-template>
                        </kendo-dropdownlist>
                        </div>

                    <div [ngClass]="{'borde_disabled': !permCamposCon, 'only_reading': deshabilitarCampos }" class="row pl-3 mt-1 borde_gris_b pb-1">
                        <label class="cb check">
                            <input type="checkbox" (click)="selectAutoriza($event)" [disabled]="!permCamposCon" [checked]="autorizaAll === 7" />
                            <span class="cb-field"></span>
                            <span class="cb-text">
                                {{ "gestion_terceros.contactInformation.autoriza_ser_contactado_por" | translate}}</span>
                        </label>
                    </div>

                    <div>

                        <div class="row ml-2 mt-1" [ngClass]="{'only_reading': deshabilitarCampos }">
                            <div class="col-6 reset">

                                <label class="cb check">
                                    <input type="checkbox" (click)="selectBox($event)" [disabled]="!permCamposCon" [checked]="telefono.IsActivated"
                                        id="telefono" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text"> {{ "labels.telephone" | translate}}</span>
                                </label>

                                <label class="cb check">
                                    <input type="checkbox" (click)="selectBox($event)" [disabled]="!permCamposCon" [checked]="mailing.IsActivated"
                                        id="mailing" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text"> {{ "labels.mailing" | translate}}</span>
                                </label>

                                <label class="cb check">
                                    <input type="checkbox" (click)="selectBox($event)" [disabled]="!permCamposCon" [checked]="sms.IsActivated"
                                        id="sms" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text"> {{ "labels.sms" | translate}}</span>
                                </label>

                                <label class="cb check">
                                    <input type="checkbox" (click)="selectBox($event)" [disabled]="!permCamposCon" [checked]="whatsApp.IsActivated"
                                        id="whatsApp" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text"> {{ "labels.whatsApp" | translate}}</span>
                                </label>
                            </div>

                            <div class="col-6 reset">

                                <label class="cb check" >
                                    <input type="checkbox" (click)="selectBox($event)"
                                        [checked]="redesSociales.IsActivated" [disabled]="!permCamposCon" id="redesSociales" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text"> {{ "labels.redes_sociales" | translate}}</span>
                                </label>

                                <label class="cb check">
                                    <input type="checkbox" (click)="selectBox($event)"
                                        [checked]="correoPostal.IsActivated" [disabled]="!permCamposCon" id="correoPostal" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text"> {{ "labels.correo_postal" | translate}}</span>
                                </label>

                                <label class="cb check">
                                    <input type="checkbox" (click)="selectBox($event)" [disabled]="!permCamposCon" [checked]="fax.IsActivated"
                                        id="fax"/>
                                    <span class="cb-field"></span>
                                    <span class="cb-text"> {{ "labels.fax" | translate}}</span>
                                </label>

                            </div>
                        </div>

                        <div *ngIf="(filial !== 'ST' && filial !== 'ER')" [ngClass]="{'borde_disabled': !permCamposCon, 'only_reading': deshabilitarCampos}" class="row pt-1 borde_gris_t">
                            <div class="col-12">
                                <label class="cb check">
                                    <input type="checkbox" id="allowContactBrand" formControlName="allowContactBrand" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text">
                                        {{ "gestion_terceros.contactInformation.Permitir_comunicaciones_Marca" | translate}}</span>
                                </label>

                                <label class="cb check">
                                    <input type="checkbox" [disabled]="!permCamposCon" id="thirdAssignment"
                                        formControlName="thirdAssignment" />
                                    <span class="cb-field"></span>
                                    <span class="cb-text">
                                        {{ "gestion_terceros.contactInformation.cesion_GDPR" | translate}}</span>
                                </label>
                                <label class="cb check">
                                    <input type="checkbox" [disabled]="!permCamposCon" id="allowProfilingBrand"
                                        formControlName="allowProfilingBrand"/>
                                    <span class="cb-field"></span>
                                    <span class="cb-text">
                                        {{ "gestion_terceros.contactInformation.perfilado_marca" | translate}}</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>



                <div class="col-6 reset">

                    <div class="row reset">
                        <label [ngClass]="{'text_disabled': !permFechaFirma}" class="w-50 text-bold mt-1">
                            {{'gestion_terceros.contactInformation.fecha_firma_GDPR' | translate}}</label>

                        <div class="gestion_terceros anchurax40 mb-1">
                            <calendario [classError]="_gestionTercerosService.customerForm.get('contactInformation').get('dateSignatureConsentDocument').invalid"
                                [disabled]="!permFechaFirma" [showButtonBar]="true" class="calendario"
                                [formulario]="_gestionTercerosService.customerForm.controls.contactInformation"
                                [controlName]="'dateSignatureConsentDocument'">
                            </calendario>
                        </div>
                    </div>

                    <div [ngClass]="{'borde_disabled': !permFechaFinalidades}" class="row pl-3 borde_gris_b mb-1">
                        <span [ngClass]="{'text_disabled': !permFechaFinalidades}" class="text-bold anchurax55">
                            {{ 'gestion_terceros.contactInformation.finalidades_GDPR' | translate}}</span>
                        <span [ngClass]="{'text_disabled': !permFechaFinalidades}" class=""> {{ 'gestion_terceros.contactInformation.validez_GDPR' | translate}}</span>
                    </div>

                    <form [formGroup]="formGroupFinalidades">

                        <div class="row reset contact_date">
                            <label [ngClass]="{'text_disabled': !permFechaFinalidades}" class="w-50 text-not-over">
                                {{'gestion_terceros.contactInformation.GDPR_purpose_CA' | translate}}</label>
                            <div class="gestion_terceros anchurax40 mb-1">
                                <calendario [disabled]="!permFechaFinalidades" [showButtonBar]="true" class="calendario"
                                    [formulario]="formGroupFinalidades" [controlName]="'findCA'">
                                </calendario>
                            </div>
                        </div>

                        <div class="row reset contact_date l-line2">
                            <label [ngClass]="{'text_disabled': !permFechaFinalidades}" class="w-50 text-not-over">
                                {{'gestion_terceros.contactInformation.GDPR_purpose_CC' | translate}}</label>
                            <div class="gestion_terceros anchurax40 mb-1 ">
                                <calendario [disabled]="!permFechaFinalidades" [showButtonBar]="true" class="calendario"
                                    [formulario]="formGroupFinalidades" [controlName]="'findCC'">
                                </calendario>
                            </div>
                        </div>

                        <div class="row reset contact_date">
                            <label [ngClass]="{'text_disabled': !permFechaFinalidades}" class="w-50 text-not-over">
                                {{'gestion_terceros.contactInformation.GDPR_purpose_ES' | translate}}</label>
                            <div class="gestion_terceros anchurax40 mb-1">
                                <calendario [disabled]="!permFechaFinalidades" [showButtonBar]="true" class="calendario"
                                    [formulario]="formGroupFinalidades" [controlName]="'findES'">
                                </calendario>
                            </div>
                        </div>

                        <div class="row reset contact_date">
                            <label [ngClass]="{'text_disabled': !permFechaFinalidades}" class="w-50 text-not-over">
                                {{'gestion_terceros.contactInformation.GDPR_purpose_PE' | translate}}</label>
                            <div class="gestion_terceros anchurax40 mb-1">
                                <calendario [disabled]="!permFechaFinalidades" [showButtonBar]="true" class="calendario"
                                    [formulario]="formGroupFinalidades" [controlName]="'findPE'">
                                </calendario>
                            </div>
                        </div>

                        <div class="row reset contact_date">
                            <label [ngClass]="{'text_disabled': !permFechaFinalidades}" class="w-50 text-not-over">
                                {{'gestion_terceros.contactInformation.GDPR_purpose_OT' | translate}}</label>
                            <div class="gestion_terceros anchurax40 mb-1 ">
                                <calendario [disabled]="!permFechaFinalidades" [showButtonBar]="true" class="calendario"
                                    [formulario]="formGroupFinalidades" [controlName]="'findOT'">
                                </calendario>
                            </div>
                            <div class="gdpr_c col-11 altura1_7 mt-2" *ngIf="!formMode && modoEdicion">
                                <p class=" text-bold mt-0 cursor" (click)="abrirExcel()">
                                    {{  "gestion_terceros.contactInformation.log_GDPR" | translate }}:
                                    <span class="k-icon k-i-file-excel mr-1 color_green"></span>
                                </p>
                            </div>
                        </div>

                        <div *ngIf="!formMode && modoEdicion && (filial !== 'ST' && filial !== 'ER')" (click)="impConsentimientos()" class="row reset contact_date">
                            <label class="w-50 text-not-over imp_consentimientos">
                                {{'gestion_terceros.contactInformation.imp_consentimientos' | translate}}:
                                <i class="fa fa-print"></i>
                            </label>
                        </div>
                    </form>
                </div>
            </div>



        </div>
    </div>
</form>
